import { render, staticRenderFns } from "./KendaraanDerekHarianPage.vue?vue&type=template&id=5b24e3f6"
import script from "./KendaraanDerekHarianPage.vue?vue&type=script&lang=js"
export * from "./KendaraanDerekHarianPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports